<div class="p-4">
    <mat-icon id="iconClose" class="cursor-pointer position-absolute close-icon icon-button" (click)="onClick()" tabindex="5">close</mat-icon>
</div>
